import { Camera, Database, ImagePlus, MapPin, Sparkles } from 'lucide-react';

type Props = {
  busy: boolean;
  error: string;
  nameReviewCount: number;
  locationReviewCount: number;
  onTakePhoto: () => void;
  onChoosePhoto: () => void;
  onFind: () => void;
  onReviewNames: () => void;
  onReviewLocations: () => void;
};

export function CameraScreen({ busy, error, nameReviewCount, locationReviewCount, onTakePhoto, onChoosePhoto, onFind, onReviewNames, onReviewLocations }: Props) {
  return (
    <main className="capture-screen">
      <div className="capture-topbar">
        <span className="capture-brand"><Database size={18} aria-hidden="true" />Household items</span>
        <div className="camera-review-actions">
          {nameReviewCount ? <button type="button" onClick={onReviewNames}><Sparkles size={16} />{nameReviewCount}<span> name{nameReviewCount === 1 ? '' : 's'}</span></button> : null}
          {locationReviewCount ? <button type="button" onClick={onReviewLocations}><MapPin size={16} />{locationReviewCount}<span> place{locationReviewCount === 1 ? '' : 's'}</span></button> : null}
        </div>
      </div>

      <section className="capture-prompt" aria-labelledby="capture-title">
        <div className="capture-icon"><Camera size={42} strokeWidth={1.8} aria-hidden="true" /></div>
        <h1 id="capture-title">Add a household item</h1>
        <p>Take a clear photo, then add its name and where the family keeps it.</p>
        <button className="capture-primary" type="button" onClick={onTakePhoto} disabled={busy}>
          {busy ? <span className="spinner dark" aria-hidden="true" /> : <Camera size={22} aria-hidden="true" />}
          {busy ? 'Preparing photo…' : 'Take a photo'}
        </button>
        <button className="capture-secondary" type="button" onClick={onChoosePhoto} disabled={busy}><ImagePlus size={20} aria-hidden="true" />Choose from photos</button>
        {error ? <p className="capture-error" role="alert">{error}</p> : null}
      </section>

      <button className="capture-find" type="button" onClick={onFind}><Database size={22} aria-hidden="true" /><span>Find saved items</span></button>
    </main>
  );
}
